import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class TicketGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const id = route.params['id'];

        if (!id) {
            window.location.href = 'https://helpPage';
            return false;
        }
        return true;
    }
}
